import React, { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";

const OtherAccount = ({ donor_id, current_phone_number }) => {
  const [loading, setLoading] = useState(false);

  // console.log("number",current_phone_number)

  const [otherAccountData, setOtherAccountData] = useState([]);
  const [noOtherAccount, setNoOtherAccount] = useState(false);
  const axiosAPI = useAxios();

//   console.log(donor_id, current_phone_number);

  const fetchFollowUpRemarkDataById = async () => {
    setLoading(true);
    setNoOtherAccount(false);
    try {
      const response = await axiosAPI.get(
        `/api/donor/donor-phone-records/${current_phone_number}`
      );
      if (response.data.record) {
        // Only 1 record → show message
        setOtherAccountData([response.data.record]); // Still table requires array
        setNoOtherAccount(true); //single Record
      } else if (response.data.records) {
        // Multiple records
        setOtherAccountData(response.data.records);
      }
    } catch (error) {
      setOtherAccountData([]);
      if (error.response?.data?.message) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "Something went wrong", "danger");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (current_phone_number) {
      fetchFollowUpRemarkDataById();
    }
  }, [current_phone_number]);

  return (
    <div>
      <div className="page-inner">
        {/* Gifts Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-end flex-wrap gap-3">
                {/* Title */}
                <h4 className="card-title mb-0">
                  All OTher Accounts (
                  {/* {noOtherAccount ? 1 : otherAccountData?.length || 0}) */}
                  {noOtherAccount ? 0 : otherAccountData?.length || 0})
                </h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Donor id</th>
                        <th>Full Name</th>
                        <th>Phone Number</th>
                        <th>Patronship Level</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : otherAccountData.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : noOtherAccount ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No other account found
                          </td>
                        </tr>
                      ) : (
                        otherAccountData.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item?.donor_id}</td>
                            <td>{item?.full_name}</td>
                            <td>{item?.phone_number}</td>
                            <td>{item?.patronship_level}</td>
                            <td>{item?.status}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherAccount;
